import { routeList } from '@/router/helpers/routes'
/* Views */
import Favorites from '@/views/Favorites'

export default [{
	path: routeList.FAVORITES_PATH,
	name: routeList.FAVORITES_NAME,
	component: Favorites
}]
